import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {AuthGuard} from '../modules/auth/_guards/auth.guard';
import {MainComponent} from "./main/main.component";
import {HomeComponent} from "./home/home.component";
import {SettingsComponent} from "./settings/settings.component";
import {RouterPaths} from "../config/router-paths.model";
import {SupportComponent} from "./support/support.component";

const routes: Routes = [
    {
        path: '', component: MainComponent, children: [
            {path: RouterPaths.home, component: HomeComponent},
            {path: RouterPaths.termsAndConditions, loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)},
            {path: RouterPaths.settings, component: SettingsComponent, canActivate: [AuthGuard]},
            {path: RouterPaths.support, component: SupportComponent, canActivate: [AuthGuard]},
            {path: '**', redirectTo: '', pathMatch: 'full'}
        ]
    }
];



@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PagesModule {
}
